function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "m19.077 4.55 1.847-.942a1.27 1.27 0 0 1 1.71.557l.942 1.85c.185.362.532.615.934.679l2.046.325c.694.11 1.168.763 1.058 1.458l-.324 2.05c-.063.403.07.812.357 1.1l1.465 1.468a1.275 1.275 0 0 1 0 1.802l-1.465 1.468c-.288.288-.42.698-.357 1.1l.324 2.05a1.274 1.274 0 0 1-1.058 1.458l-2.046.325c-.402.064-.75.317-.934.68l-.942 1.85a1.271 1.271 0 0 1-1.71.556l-1.847-.942a1.271 1.271 0 0 0-1.154 0l-1.847.942a1.271 1.271 0 0 1-1.71-.556l-.942-1.85a1.274 1.274 0 0 0-.934-.68l-2.046-.325a1.274 1.274 0 0 1-1.058-1.457l.324-2.05a1.278 1.278 0 0 0-.357-1.101l-1.465-1.468a1.275 1.275 0 0 1 0-1.802l1.465-1.468c.288-.288.42-.697.357-1.1l-.324-2.05a1.274 1.274 0 0 1 1.058-1.458l2.046-.325c.402-.064.75-.317.934-.68l.942-1.849a1.27 1.27 0 0 1 1.71-.557l1.847.942c.362.185.792.185 1.154 0zm6.395 21.058v7.46l-6.96-4.874-6.964 4.875v-7.222m1.197-11.818a5.827 5.827 0 0 1 5.822-5.832 5.827 5.827 0 0 1 5.822 5.832 5.827 5.827 0 0 1-5.822 5.832 5.825 5.825 0 0 1-5.822-5.832z",
  stroke: "#2E4A8B",
  strokeWidth: 2,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
const SvgIconBrandIconAward = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 37,
  height: 37,
  viewBox: "0 0 37 37",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconBrandIconAward, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-brand-icon-award.ae5936ea.svg";
export { ForwardRef as ReactComponent };